// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1PA_U","primary":"Button_primary__2E_Ac","round":"Button_round__3WSiA"};